import { TextInput, TextInputProps } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form/lib/use-form"
import { useContext } from "react"
import { EditingContext } from "../editingContext"
import { KeysOfType } from "~/utils/types"
import { ReadOnlyInput } from "./ReadOnlyInput"

type StringInputProps<
  T extends Record<K, string | null>,
  K extends KeysOfType<T, string | null>
> = Omit<TextInputProps, "form" | "value" | "onChange" | "error"> & {
  form: UseFormReturnType<T>
  field: K
  adminLabel?: string
}

export const StringInput = <
  T extends Record<K, string | null>,
  K extends KeysOfType<T, string | null>
>({
  form,
  field,
  type,
  onBlur,
  placeholder,
  adminLabel,
  ...props
}: StringInputProps<T, K>) => {
  const editing = useContext(EditingContext)

  return editing ? (
    <TextInput
      type={type ?? "text"}
      {...form.getInputProps(field)}
      value={form.values[field] ?? ""}
      onBlur={(event) => {
        form.validateField(field)
        onBlur && onBlur(event)
      }}
      placeholder={form.errors[field] ? "" : placeholder}
      {...props}
    />
  ) : (
    <ReadOnlyInput
      value={form.values[field]}
      placeholder={placeholder}
      adminLabel={adminLabel}
      error={field in form.errors}
      {...props}
    />
  )
}
